// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assests/images/wallpaper.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assests/images/bg6.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .table-header th {
    background-color: skyblue;
   
  } */
.qr-code-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  font-size: 10px;
}

.qr-con {
  border: 20px solid #96dc00;
  border-radius: 10px;
  margin-top: 5px;
  margin: 5px;
  width: calc(40% - 20px);

  box-sizing: border-box;
}

.qr-con .row {
  display: flex;
  flex-direction: row;
}

.qr-view-container {
  display: block;
  justify-content: center;
  align-items: center;
  height: 100vh;
}


.qr-box {
  border: 1px solid #000;
  padding: 20px;
  margin: 40px 40%;
  border-radius: 10px 20px 10px 30px;
}

.toastBody {
  font-size: 1rem;
}

.login-wall {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  background-size: cover;
  background-position: center;

  width: 100%;
}

.progress-bar-fill {
  height: 20px;
  /* Adjust height as needed */
  display: flex;
  /* Arrange segments side-by-side */
  position: relative;
  /* Enable positioning for the animation */
}

.progress-bar-fill span {
  /* Adjust individual segment styling */
  transition: width 0.5s ease-in-out;
  /* Add smooth transition */
}



.progress-bar-animation {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 100%;
  background-color: #fff;
  transition: width 0.5s ease-in-out;
}

.tooltip {

  position: absolute;
  top: -30px;
}

@media print {
  .header {
    display: none !important;
  }

  .no-print {
    display: none !important;
  }

  body {
    margin: 20px;
    overflow: visible !important;

  }

  .pdf-container .table thead {
    background: #F0E9EA;
  }


}

.content-wrapper {
  margin-left: 10px !important;
  margin-right: 10px !important;

}

/* App.css */
/* .app-container {
  display: flex;
  flex-wrap: wrap;
}

.sidebar-container {
  width: 20%;
  min-width: 200px;
}

.content-container {
  width: 80%;
  flex-grow: 1;
} */

/* App.css */

.app-container {
  display: flex;
  flex-direction: row;
  height: 100vh;
  /* Full viewport height */
  overflow: hidden;
  /* Prevent double scrollbar */
}

.sidebar-container {
  width: 250px;
  flex-shrink: 0;
  background-color: #f8f9fa;
  transition: width 0.3s ease;
  height: 100vh;
  /* Sidebar stays fixed full height */
  overflow: hidden;
  /* Prevent sidebar scroll */
}

.sidebar-container-coll {
  width: auto !important;
  height: 100vh;
  overflow: hidden;
}

/* ✅ Scroll only content */
.content-container {
  flex-grow: 1;
  width: 80%;
  height: 100vh;
  overflow-y: auto;
  /* This enables scrolling */
  overflow-x: hidden;
  background: #ffffff;
  padding: 0px;
}

/* Optional: custom scrollbar for content */
.content-container::-webkit-scrollbar {
  width: 8px;
}

.content-container::-webkit-scrollbar-thumb {
  background: #cfd8dc;
  border-radius: 6px;
}

.content-container::-webkit-scrollbar-thumb:hover {
  background: #90a4ae;
}
@media (max-width: 480px) {
   .btn-primary{
    width: 50px;
    font-size: 0.3rem;
  }
}

@media (max-width: 768px) {
  .app-container {
    margin-left: 30px;
  }

  .sidebar-container {
    width: 100%;
    height: auto;
  }

  .content-container {
    margin-left: 0;
    padding: 10px;
  }
  table{
    display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  }
  .card-title{
    font-size: 0.8rem;
  }
  .btn-primary{
    width: 70px;
    font-size: 0.5rem;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .sidebar-container {
    width: 100px;
  }

  .content-container {
  
    padding: 15px;
    
  }
   table{
    display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  }
  .card-title{
    font-size: 0.8rem;
  }
  .btn-primary{
    width: 100px;
    font-size: 0.5rem;
  }
}

@media (max-width: 480px) {
  .content-container {
    padding: 5px;
  }

  .profile-image {
    width: 90px;
    height: 90px;
    margin: 2px;
  }

  .upload-btn {
    font-size: 12px;
    padding: 3px 10px;
  }
}
/* Container for profile image upload */
.profile-upload-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

/* Profile image wrapper */
.profile-image {
  position: relative;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  margin-bottom: 20px;
}

.profile-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Upload button styling */
.upload-btn {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 5px 15px;
  cursor: pointer;
  border-radius: 5px;
  font-size: 14px;
}

/* Input hidden */
.profile-upload-input {
  display: none;
}

/* Clear button styling */
.clear-btn {
  margin-top: 10px;
  background-color: red;
  color: white;
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.clear-btn:hover {
  background-color: darkred;
}

/* Parent container to limit overflow during zoom */
.image-container {
  position: relative;
  overflow: hidden;
  display: inline-block;
  cursor: zoom-in;
}

/* Zoom effect on hover */
.zoomable-img {
  transition: transform 0.3s ease, cursor 0.3s ease;
}

/* Zoomed in effect */
.image-container:hover .zoomable-img {
  transform: scale(1.5);
  /* Adjust scale as per requirement */
  cursor: zoom-out;
}

.ant-select-selector {
  width: 100%;
  height: calc(2.25rem + 2px) !important;
  border: none;
}

.navbar {

  padding: 0.0rem 0.1rem !important;
}

.table-responsive {
  width: 100%;
}

.table-responsive>table {
  width: 100% !important;
  table-layout: fixed;
}

.amtqty-div .text-center {
  margin-top: 0rem !important;
  padding-bottom: 0rem !important;

}

.amtqty-div .card-body {
  padding: 0.5rem !important;
}



.amtqty-div .card-body .col-3 p {
  margin-bottom: 0rem !important;

}

.p-bottom {
  margin-bottom: 0rem !important;

}

.left-column {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.agri-dash::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.5);
  /* Light scrollbar */
  border-radius: 4px;
}

.agri-dash::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  /* Transparent track */
}

.agri-dash::-webkit-scrollbar {
  width: 6px;
}

.tableheaderrowview th {
  background-color: #e8f0fe !important;
  /* Group Header like "Farmer Details" */
  color: #333;
  font-weight: bold;
  text-align: center;
}

.table-subheader th {
  background-color: #f5f5f5 !important;
  /* Column Labels */
  color: #000;
  font-weight: 500;
  text-align: center;
}

.table-row-even {
  background-color: #ffffff;
}

.table-row-odd {
  background-color: #fafafa;
}

.cursor-pointer {
  cursor: pointer;
}

/* 
.dashboard-navbar{
background-color: #498428;
} */
/* .dashboard-content{
  background-color: #fde7d4;
} */
.card-bg {
  background-color: #e0f3ff !important;
}

.dashboard-wrapper {
  position: relative;
  min-height: 100vh;
  /* ensures wrapper fills full screen */
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.dashboard-wrapper::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-position: center;
  filter: blur(5px);
  transform: scale(1.1);
  z-index: -1;
  opacity: 0.85;
}

@media(min-width: 769px) and (max-width: 1024px) {
    .content-container {
        margin-left: 220px;
        padding: 15px;
    }
   
}
.fixed-bottom-logo {
  position: fixed;
  
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  text-align: center;
}

.powered-by-text {
  display: block;
  color: #222;
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 2px;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;KAGK;AACL;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;;EAEvB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,uBAAuB;;EAEvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;;AAGA;EACE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oEAAuE;EACvE,sBAAsB;EACtB,2BAA2B;;EAE3B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,kCAAkC;EAClC,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,0BAA0B;AAC5B;;;;AAIA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,4BAA4B;;EAE9B;;EAEA;IACE,mBAAmB;EACrB;;;AAGF;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;;AAE/B;;AAEA,YAAY;AACZ;;;;;;;;;;;;;GAaG;;AAEH,YAAY;;AAEZ;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,2BAA2B;EAC3B,aAAa;EACb,oCAAoC;EACpC,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA,2CAA2C;AAC3C;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;AACA;GACG;IACC,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,cAAc;EAChB,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;;IAEE,aAAa;;EAEf;GACC;IACC,cAAc;EAChB,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,iDAAiD;AACnD;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;EACrB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,YAAY;AACd;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;;AAEjC;;AAEA;EACE,0BAA0B;AAC5B;;;;AAIA;EACE,8BAA8B;;AAEhC;;AAEA;EACE,8BAA8B;;AAEhC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0CAA0C;EAC1C,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;;;GAGG;AACH;;GAEG;AACH;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sCAAsC;EACtC,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mDAA2C;EAC3C,sBAAsB;EACtB,2BAA2B;EAC3B,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;EACX,aAAa;AACf;;AAEA;IACI;QACI,kBAAkB;QAClB,aAAa;IACjB;;AAEJ;AACA;EACE,eAAe;;EAEf,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["/* .table-header th {\n    background-color: skyblue;\n   \n  } */\n.qr-code-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n\n  font-size: 10px;\n}\n\n.qr-con {\n  border: 20px solid #96dc00;\n  border-radius: 10px;\n  margin-top: 5px;\n  margin: 5px;\n  width: calc(40% - 20px);\n\n  box-sizing: border-box;\n}\n\n.qr-con .row {\n  display: flex;\n  flex-direction: row;\n}\n\n.qr-view-container {\n  display: block;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n\n.qr-box {\n  border: 1px solid #000;\n  padding: 20px;\n  margin: 40px 40%;\n  border-radius: 10px 20px 10px 30px;\n}\n\n.toastBody {\n  font-size: 1rem;\n}\n\n.login-wall {\n  background-image: url(\"../src/assests/images/wallpaper.jpg\") !important;\n  background-size: cover;\n  background-position: center;\n\n  width: 100%;\n}\n\n.progress-bar-fill {\n  height: 20px;\n  /* Adjust height as needed */\n  display: flex;\n  /* Arrange segments side-by-side */\n  position: relative;\n  /* Enable positioning for the animation */\n}\n\n.progress-bar-fill span {\n  /* Adjust individual segment styling */\n  transition: width 0.5s ease-in-out;\n  /* Add smooth transition */\n}\n\n\n\n.progress-bar-animation {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 0;\n  height: 100%;\n  background-color: #fff;\n  transition: width 0.5s ease-in-out;\n}\n\n.tooltip {\n\n  position: absolute;\n  top: -30px;\n}\n\n@media print {\n  .header {\n    display: none !important;\n  }\n\n  .no-print {\n    display: none !important;\n  }\n\n  body {\n    margin: 20px;\n    overflow: visible !important;\n\n  }\n\n  .pdf-container .table thead {\n    background: #F0E9EA;\n  }\n\n\n}\n\n.content-wrapper {\n  margin-left: 10px !important;\n  margin-right: 10px !important;\n\n}\n\n/* App.css */\n/* .app-container {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.sidebar-container {\n  width: 20%;\n  min-width: 200px;\n}\n\n.content-container {\n  width: 80%;\n  flex-grow: 1;\n} */\n\n/* App.css */\n\n.app-container {\n  display: flex;\n  flex-direction: row;\n  height: 100vh;\n  /* Full viewport height */\n  overflow: hidden;\n  /* Prevent double scrollbar */\n}\n\n.sidebar-container {\n  width: 250px;\n  flex-shrink: 0;\n  background-color: #f8f9fa;\n  transition: width 0.3s ease;\n  height: 100vh;\n  /* Sidebar stays fixed full height */\n  overflow: hidden;\n  /* Prevent sidebar scroll */\n}\n\n.sidebar-container-coll {\n  width: auto !important;\n  height: 100vh;\n  overflow: hidden;\n}\n\n/* ✅ Scroll only content */\n.content-container {\n  flex-grow: 1;\n  width: 80%;\n  height: 100vh;\n  overflow-y: auto;\n  /* This enables scrolling */\n  overflow-x: hidden;\n  background: #ffffff;\n  padding: 0px;\n}\n\n/* Optional: custom scrollbar for content */\n.content-container::-webkit-scrollbar {\n  width: 8px;\n}\n\n.content-container::-webkit-scrollbar-thumb {\n  background: #cfd8dc;\n  border-radius: 6px;\n}\n\n.content-container::-webkit-scrollbar-thumb:hover {\n  background: #90a4ae;\n}\n@media (max-width: 480px) {\n   .btn-primary{\n    width: 50px;\n    font-size: 0.3rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .app-container {\n    margin-left: 30px;\n  }\n\n  .sidebar-container {\n    width: 100%;\n    height: auto;\n  }\n\n  .content-container {\n    margin-left: 0;\n    padding: 10px;\n  }\n  table{\n    display: block;\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  }\n  .card-title{\n    font-size: 0.8rem;\n  }\n  .btn-primary{\n    width: 70px;\n    font-size: 0.5rem;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n  .sidebar-container {\n    width: 100px;\n  }\n\n  .content-container {\n  \n    padding: 15px;\n    \n  }\n   table{\n    display: block;\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  }\n  .card-title{\n    font-size: 0.8rem;\n  }\n  .btn-primary{\n    width: 100px;\n    font-size: 0.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .content-container {\n    padding: 5px;\n  }\n\n  .profile-image {\n    width: 90px;\n    height: 90px;\n    margin: 2px;\n  }\n\n  .upload-btn {\n    font-size: 12px;\n    padding: 3px 10px;\n  }\n}\n/* Container for profile image upload */\n.profile-upload-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 20px;\n}\n\n/* Profile image wrapper */\n.profile-image {\n  position: relative;\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n  overflow: hidden;\n  margin-bottom: 20px;\n}\n\n.profile-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Upload button styling */\n.upload-btn {\n  position: absolute;\n  bottom: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.5);\n  color: white;\n  padding: 5px 15px;\n  cursor: pointer;\n  border-radius: 5px;\n  font-size: 14px;\n}\n\n/* Input hidden */\n.profile-upload-input {\n  display: none;\n}\n\n/* Clear button styling */\n.clear-btn {\n  margin-top: 10px;\n  background-color: red;\n  color: white;\n  padding: 5px 10px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.clear-btn:hover {\n  background-color: darkred;\n}\n\n/* Parent container to limit overflow during zoom */\n.image-container {\n  position: relative;\n  overflow: hidden;\n  display: inline-block;\n  cursor: zoom-in;\n}\n\n/* Zoom effect on hover */\n.zoomable-img {\n  transition: transform 0.3s ease, cursor 0.3s ease;\n}\n\n/* Zoomed in effect */\n.image-container:hover .zoomable-img {\n  transform: scale(1.5);\n  /* Adjust scale as per requirement */\n  cursor: zoom-out;\n}\n\n.ant-select-selector {\n  width: 100%;\n  height: calc(2.25rem + 2px) !important;\n  border: none;\n}\n\n.navbar {\n\n  padding: 0.0rem 0.1rem !important;\n}\n\n.table-responsive {\n  width: 100%;\n}\n\n.table-responsive>table {\n  width: 100% !important;\n  table-layout: fixed;\n}\n\n.amtqty-div .text-center {\n  margin-top: 0rem !important;\n  padding-bottom: 0rem !important;\n\n}\n\n.amtqty-div .card-body {\n  padding: 0.5rem !important;\n}\n\n\n\n.amtqty-div .card-body .col-3 p {\n  margin-bottom: 0rem !important;\n\n}\n\n.p-bottom {\n  margin-bottom: 0rem !important;\n\n}\n\n.left-column {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.agri-dash::-webkit-scrollbar-thumb {\n  background-color: rgba(255, 255, 255, 0.5);\n  /* Light scrollbar */\n  border-radius: 4px;\n}\n\n.agri-dash::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.1);\n  /* Transparent track */\n}\n\n.agri-dash::-webkit-scrollbar {\n  width: 6px;\n}\n\n.tableheaderrowview th {\n  background-color: #e8f0fe !important;\n  /* Group Header like \"Farmer Details\" */\n  color: #333;\n  font-weight: bold;\n  text-align: center;\n}\n\n.table-subheader th {\n  background-color: #f5f5f5 !important;\n  /* Column Labels */\n  color: #000;\n  font-weight: 500;\n  text-align: center;\n}\n\n.table-row-even {\n  background-color: #ffffff;\n}\n\n.table-row-odd {\n  background-color: #fafafa;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n/* \n.dashboard-navbar{\nbackground-color: #498428;\n} */\n/* .dashboard-content{\n  background-color: #fde7d4;\n} */\n.card-bg {\n  background-color: #e0f3ff !important;\n}\n\n.dashboard-wrapper {\n  position: relative;\n  min-height: 100vh;\n  /* ensures wrapper fills full screen */\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.dashboard-wrapper::before {\n  content: \"\";\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: url('./assests/images/bg6.jpg');\n  background-size: cover;\n  background-position: center;\n  filter: blur(5px);\n  transform: scale(1.1);\n  z-index: -1;\n  opacity: 0.85;\n}\n\n@media(min-width: 769px) and (max-width: 1024px) {\n    .content-container {\n        margin-left: 220px;\n        padding: 15px;\n    }\n   \n}\n.fixed-bottom-logo {\n  position: fixed;\n  \n  bottom: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1000;\n  text-align: center;\n}\n\n.powered-by-text {\n  display: block;\n  color: #222;\n  font-size: 1rem;\n  font-weight: bold;\n  margin-bottom: 2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
